import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'number',
  standalone: true
})
export class NumberPipe implements PipeTransform {

  transform(value: unknown, decimals: number = 2): unknown {
    if (value === null || value === undefined || value === '') {
      return '0';
    }

    const num = Number(value);
    if (isNaN(num)) {
      return '0';
    }

    if (Math.abs(num) < 1000) {
      return num.toFixed(decimals);
    }

    const units = [
      { value: 1e12, symbol: 'T' },
      { value: 1e9, symbol: 'B' },
      { value: 1e6, symbol: 'M' },
      { value: 1e3, symbol: 'K' }
    ];

    for (const unit of units) {
      if (Math.abs(num) >= unit.value) {
        const formatted = (Math.abs(num) / unit.value).toFixed(decimals);
        const result = formatted + unit.symbol;
        return (num < 0 ? '-' : '') + result;
      }
    }

    return num.toFixed(decimals);
  }

}
